import type { Dispatch, SetStateAction } from "react";

import { FLAGS } from "@app/dashboard/constants/flags";
import { useMerchantFlags } from "@app/dashboard/hooks/useMerchantFlags";
import type { TNavTabs } from "@app/dashboard/types/innerLayout/checkout_customization";
import { NavigationTabs } from "../components/NavigationTabs";
import { BrandingTab } from "./tabs/Branding";
import { PaymentsTab } from "./tabs/Payment";
import { PostPaymentTab } from "./tabs/PostPayment";
import { NAVIGATION_TABS } from "../utils";
import styles from "./checkout-customization-sidebar.module.scss";


const SIDEBAR_CONTENT_ID = "ch-custom-sidebar";


export const Sidebar = ({
  activeTab,
  setActiveTab
}: {
  activeTab: TNavTabs,
  setActiveTab: Dispatch<SetStateAction<TNavTabs>>
}) => {

  const { flagsQuery: data } = useMerchantFlags();
  const flags = data.data;

  const relatedFlags = [
    FLAGS.INSTANT_REFUND,
    FLAGS.SPLIT_PAYMENT
  ];

  const merchantFlags: string[] = flags?.reduce((acc: string[], item: Record<string, boolean>) => {
    const key = Object.keys(item)[0];

    if (relatedFlags.includes(key) && item[key]) {
      acc.push(key);
    }

    return acc;
  }, []) ?? [];


  return (
    <div className={styles["ch-custom-sidebar"]}>

      <NavigationTabs
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />

      <div className={styles["ch-custom-sidebar__main"]} id={SIDEBAR_CONTENT_ID}>
        {
          activeTab === NAVIGATION_TABS.BRANDING ?
            <BrandingTab />
            :
            activeTab === NAVIGATION_TABS.PAYMENT ?
              <PaymentsTab merchantFlags={merchantFlags} />
              :
              activeTab === NAVIGATION_TABS.POST_PAYMENT && <PostPaymentTab />
        }
      </div>
    </div>
  )
}
